<template>
  <div v-if="badgeList && badgeList.length > 0">
    <tk-badge v-for="(badge, index) in badgeList"
              :key="index"
              :badge-text="badge.text"
              :badge-class="badge.class"
              :qaid="badge.qaid || badge.id"
    />
  </div>
</template>
<script>
import TkBadge from '@/components/TkBadge.vue';
import { qaidMixin } from '@/utils/qaid-helper';

export default {
  name: 'BadgeGroup',
  mixins: [qaidMixin],
  components: {TkBadge},
  props: {
    badges: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    badges: {
      deep: true,
      handler () {
        this.badgeList = this.badges;
      }
    }
  },
  mounted () {
    this.badgeList = this.badges;
  },
  data () {
    return {
      badgeList: []
    };
  }
}
</script>
